 
import api from '../../interceptorServices';
import base_url from '../../../config';

const path = base_url+'api/admin/abstractType';

export const getData = async () => {
  const response = await api.get(path);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};